import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-guest-participant-section-header",
  templateUrl: "./guest-participant-section-header.component.html",
  styleUrls: ["./guest-flow.component.css"],
  standalone: false
})
export class GuestParticipantSectionHeaderComponent {
  @Input() public title = "";
  @Input() public chatLabel = "";

  @Output() public chat = new EventEmitter<void>();
}
